module.exports = __webpack_public_path__ + "assets/img/1.d9d061e9.png";